import { Delete } from '@/components/Icons'

import messages from './messages'

export default ({ intl, showConfirmDelete }: any) => [
  {
    property: 'displayName',
    header: {
      label: intl.formatMessage(messages.name),
      sortable: true
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => <span className="keyvalues__label">{rowData.displayName}</span>]
    }
  },
  {
    property: 'email',
    header: {
      label: intl.formatMessage(messages.email)
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => <span className="sub-text">{rowData.email}</span>]
    }
  },
  {
    property: 'id',
    cell: {
      props: {
        style: {
          width: 50
        }
      },
      // TODO Remove this onClick and  wrap it in a button
      formatters: [(id: any, { rowData }: any) => <Delete onClick={() => showConfirmDelete(rowData)} />]
    }
  }
]
